/**
 * 格式轉換公式
 */

/**
 * 英文大寫轉換
 * @param val
 * @returns
 */
const toUpperCase = (val: string) => {
  if (!val) return '';
  return val.toUpperCase();
};
export { toUpperCase };
